import React from "react";

/**
 * Etoiles IA — en-tete du tiroir et entree du menu lateral.
 *
 * Version vectorielle monochrome : les icones du menu lateral changent de
 * couleur selon l'onglet actif, ce qu'un PNG ne permet pas. Le logo de marque
 * (PNG, voir IaLogo.jsx) reste sur le bouton flottant et l'ecran d'accueil.
 */
/* Pas de fill="none" sur le <svg> : le menu lateral passe `null` comme couleur
   quand l'onglet est inactif — la valeur par defaut ne s'applique alors pas et
   l'attribut fill du path disparait. Le path doit retomber sur le noir par
   defaut du SVG, comme toutes les autres icones du menu, et non sur `none`. */
export const IaAssistantSvg = ({ size = 24, color = "#1d4955" }) => (
  <svg width={size} height={size} viewBox="0 0 30 30">
    <path
      d="M13.95 6.805l.654 3.06c.593 2.773 2.759 4.939 5.532 5.532l3.06.654c1.024.219 1.024 1.68 0 1.899l-3.06.654c-2.773.593-4.939 2.759-5.532 5.532l-.654 3.06c-.219 1.024-1.68 1.024-1.899 0l-.654-3.06c-.593-2.773-2.759-4.939-5.532-5.532l-3.06-.654c-1.024-.219-1.024-1.68 0-1.899l3.06-.654c2.773-.593 4.939-2.759 5.532-5.532l.654-3.06C12.269 5.781 13.731 5.781 13.95 6.805zM23.641 2.525l.588 2.119c.152.547.58.975 1.127 1.127l2.119.588c.65.18.65 1.102 0 1.282l-2.119.588c-.547.152-.975.58-1.127 1.127l-.588 2.119c-.18.65-1.102.65-1.282 0l-.588-2.119c-.152-.547-.58-.975-1.127-1.127l-2.119-.588c-.65-.18-.65-1.102 0-1.282l2.119-.588c.547-.152.975-.58 1.127-1.127l.588-2.119C22.539 1.875 23.461 1.875 23.641 2.525z"
      fill={color}
    />
  </svg>
);

export const IaSendSvg = ({ size = 18, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3.4 20.4 21 12 3.4 3.6 3.4 10.2 15 12 3.4 13.8Z"
      fill={color}
    />
  </svg>
);

export const IaHistorySvg = ({ size = 18, color = "#1d4955" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 7v5l3 2"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1M3.5 4.5V9H8"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IaPlusSvg = ({ size = 18, color = "#1d4955" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5v14M5 12h14"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const IaGlobeSvg = ({ size = 16, color = "#1d4955" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.6" />
    <path
      d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z"
      stroke={color}
      strokeWidth="1.6"
    />
  </svg>
);

export const IaClipSvg = ({ size = 18, color = "#1d4955" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M20 11.5 12.3 19.2a4.5 4.5 0 0 1-6.4-6.4l7.8-7.8a3 3 0 1 1 4.3 4.3l-7.8 7.8a1.5 1.5 0 0 1-2.1-2.1l7.1-7.1"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
